<template>
  <div class="box">
    <div class="headline">
      <div class="top">{{ title }}</div>
    </div>

    <div v-if="inFlight">
      <p class="text-center">
        Generating your project, please wait ...
      </p>
      <p class="text-center">
        <font-awesome-icon icon="spinner" spin size="lg" />
      </p>
    </div>

    <div v-else-if="archiveUrl" class="text-center">
      <h4 class="my-4">
        All done!
      </h4>
      <p>
        New code for your project <strong>{{ recipe.name }}</strong> has been generated.
      </p>
      <p>
        <b-button :href="archiveUrl" variant="primary">
          Download ZIP archive
        </b-button>
        <b-button :href="projectUrl">
          Back to project
        </b-button>
      </p>
    </div>
    <div v-else-if="error">
      <p class="text-danger">
        There was an error while generating your project.
      </p>
      <p>
        {{ errorTitle }}
      </p>

      <p>
        You can tweak the configuration by going
        <a href="#" @click.prevent="onPrev">back</a> to previous
        steps.
      </p>
    </div>

    <div v-else>
      <p>
        You're almost done!
      </p>
      <p>
        Please add a short description of your change(s), like you would
        in a git commit message, then press <strong>Generate</strong> to
        generate your code.
      </p>

      <b-form @submit.prevent="generate">
        <b-form-group label="Description" description="Example: Add a Book model, or Enable Heroku support, or Initial version">
          <b-form-input v-model="description" ref="commitMessage"></b-form-input>
        </b-form-group>

        <div class="button-row">
          <b-button @click="onPrev">&larr; Prev</b-button>
          <b-button variant="primary" @click="generate">Generate code</b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import { generateProject } from '../../helpers/client'

export default {
  name: 'Generate',

  props: {
    generateUrl: {type: String, required: true},
    projectUrl: {type: String, required: true},
    recipe: {type: Object, required: true}
  },

  data () {
    return {
      inFlight: false,
      error: null,
      archiveUrl: null,
      description: ''
    }
  },

  computed: {
    title () {
      if (this.inFlight) return 'Creating project ...'
      if (this.archiveUrl) return 'Project created'
      if (this.error) return 'Error creating project :('
      return 'Almost there ...'
    },

    errorTitle () {
      if (!this.error) return null
      const error = this.error.error

      if (!error) return 'Unknown error'

      if (typeof error === 'string') return this.error
      return error.message || 'Unknown error'
    }
  },

  methods: {
    onPrev () {
      this.$emit('prev')
    },

    async generate () {
      this.inFlight = true

      try {
        const response = await generateProject(this.recipe, this.description, this.generateUrl)
        this.archiveUrl = response.archive_url
      } catch (e) {
        console.error('Error generating project', e)
        this.error = e
        this.$emit('error', JSON.stringify(e))
      }

      this.inFlight = false
    }
  },

  mounted () {
    Vue.nextTick(() => {
      this.$refs.commitMessage.focus()
    })
  }
}
</script>

<style scoped>
  pre {
    font-size: 0.8em;
  }
</style>



// WEBPACK FOOTER //
// src/components/wizard/Generate.vue